<template>
    <div fluid class="fill">
      <div v-if="!groupModal">
        <div class="d-none d-md-block d-lg-block d-sm-none">
          <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
            <!-- Right aligned nav items -->
            <b-nav class="ml-auto p-1">
              <b-button variant="primary" @click="showChooseType"><i class="icon-bubbles icons d-block"> New</i></b-button>
            </b-nav>
          </b-navbar>
        </div>
        <b-row class="margin-0">
            <b-col lg="12" md="0" class="pane-border padding-0">
              <ExtensibleHistory @show-extensible-type-chooser="setExtensibleType"/>
            </b-col>
        </b-row>
        <vue-fab
        class="d-sm-block d-md-none d-lg-none "
        :mainBtnColor="mainBtnColor"
        :icon="mainBtnIcon"
        @clickMainBtn="clickMainBtn">
          <fab-item 
              v-for="(item, idx) in menu"
              :idx="idx"
              :key="idx"
              :title="item.title"
              :color="item.color"
              :icon="item.icon"
              @clickItem="clickItem(item.link)"/>
        </vue-fab>
      </div>
      <div v-else>
        <b-navbar toggleable="md" class="bottom-border" type="light" variant="light" v-if="!isChooseTypeSelected">
          <b-nav>
              <b-nav-item @click="groupModal = false">
                <i class="icon-arrow-left icons"></i>
              </b-nav-item>
              <b-nav-item disabled> Back</b-nav-item>
          </b-nav>
        </b-navbar>
        <!-- <ChooseType/> -->
        <div class="row ml-3 pr-3 mt-3" v-if="!isChooseTypeSelected">
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('text', false)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-note icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Text</h2>
                <div class="text-center"><small class="text-center">Extend your message to 2000 characters.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('image', false)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-picture icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Image</h2>
                <div class="text-center"><small class="text-center">Add an image to your text message.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('audio', false)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-microphone icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Audio</h2>
                <div class="text-center"><small class="text-center">Add a 1 minute audio file to your message.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('video', false)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-film icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Video</h2>
                <div class="text-center"><small class="text-center">Add 1 minute video clip to your message.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('vote', true)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-like icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Vote</h2>
                <div class="text-center"><small class="text-center">Conduct private/public preference voting.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('survey', true)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-star icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Survey</h2>
                <div class="text-center"><small class="text-center">Conduct private/public preference survey.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="hand-cursor col-md-4 mb-4 col-sm-12" @click="setExtensibleType('poll', true)">
            <b-list-group-item class="flex-column align-items-start">
            <div class="row mb-2 pl-3 pr-3 text-justify">
              <div class="col-12">
                <i class="icon-heart icons mb-3 mt-3 pl-3 pr-3 text-center font-5xl d-block"></i>
              </div>
              <div class="col-12">
                <h2 class="mb-3 mt-3 pl-3 pr-3 text-center">Poll</h2>
                <div class="text-center"><small class="text-center">Conduct private/public opinion poll.</small></div>
              </div>
            </div>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          <div class="d-md-block d-lg-block">
            <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
              <b-nav>
                  <b-nav-item @click="isChooseTypeSelected = false">
                    <i class="icon-arrow-left icons"></i>
                  </b-nav-item>
                  <b-nav-item disabled> Back</b-nav-item>
              </b-nav>
            </b-navbar>
          </div>
          <b-row class="margin-0">
            <b-col lg="12" md="0" class="pane-border padding-0">
              <template v-if="!isQuestionnaire">
                <ComposeExensible :showSelectedType="showSelectedType"
                  :newsletters="newsletterOptions"/>
              </template>
              <template v-else>
                <Questionnaire 
                  :showSelectedType="showSelectedType"
                  :newsletters="newsletterOptions"/>
              </template>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
</template>
<script>

import Vue from "vue"
import { mapState, mapActions } from "vuex"
import ExtensibleHistory from '@/components/extensible-sms/ExtensibleHistory'
import ComposeExensible from '@/components/extensible-sms/ComposeExensible'
import Questionnaire from '@/components/extensible-sms/Questionnaire'
import {} from '@/services/notification.service'
import {EventBus} from '@/events/bus.event'
import router from '@/router/index'

export default {
  name: 'ExtensibleSMS',
  components: {
    ExtensibleHistory,
    ComposeExensible,
    Questionnaire,
  },
  data () {
    return {
      groupModal: false,
      isChooseTypeSelected: false,
      showSelectedType: '',
      isQuestionnaire: false,
      menu: [
          {
            icon: 'icon-bubbles icons',
            title: 'Create New Ex-SMS',
            color: '#c2185b',
            link: 'popup'
          }
        ],
      mainBtnColor: '#c2185b',
      mainBtnIcon: 'icon-menu icons',
    }
  },
  computed: {
    ...mapState('newsletter', ['newsletters', 'nextPage']),

    newsletterOptions() {
      let newsletterOptions = []
      this.newsletters.forEach(function (newsletter, key) {
        if(!newsletter.paid_sub)
          newsletterOptions.push({ value: newsletter.subcode, label: newsletter.name });
      })
      return newsletterOptions
    },

  },
  created() {
    if (this.newsletters.length <= 0) {
      this.fetchNewsletters({page:this.nextPage})
    }
  },
  methods: {
    ...mapActions('newsletter', [
        'fetchNewsletters'
    ]),

    showChooseType: function(){
      this.groupModal = true
    },
    clickItem: function (link) {
      if (link == 'popup') {
        this.showChooseType()
        return
      }
    },
    clickMainBtn: function (){

    },
    setExtensibleType: function(type, isQuestionnaire){
      this.isChooseTypeSelected = true
      this.showSelectedType = type
      this.isQuestionnaire = isQuestionnaire
      this.groupModal = true
    }
  }
} 
</script>

<style type="text/css" scoped>
  .hand-cursor {
    cursor: pointer;
  }
</style>
